<template>
  <div class="mdt-offers-upperwrap">
    <market-section
      :title="service.name"
      section-type="hotels"
    ></market-section>
  </div>
</template>

<script>
import marketSection from "../utilities/market-section.vue";

export default {
  name: "hotels",
  data: () => {
    return {
      service: {},
      category: {},
      service_id: 1,
      articles: [],
    };
  },
  components: { marketSection },
  created() {
    this.service_id = this.$route.params.id;
    this.getCategories();
    this.getService();
    //this.getArticles();
  },
  methods: {
    getService() {
      this.$http
        .get(apiUrl + "/service-types/" + this.service_id)
        .then((response) => {
          this.service = response.data;
        });
    },
    getCategories() {
      this.$http
        .get(
          apiUrl +
            `/categories?q=(service_type_id:${this.service_id})&sort=position_order|asc`
        )
        .then((response) => {
          this.category = response.data;
        });
    },
    getArticles() {
      this.$http
        .get(apiUrl + `/service-types/${this.service_id}/articles`)
        .then((response) => {
          this.articles = response.data;
        });
    },
  },
};
</script>

<style scoped>
.mdt-offers-upperwrap {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// services.vue?4068f410